import {
  IPlatformInfo,
  IPlatformInfoData,
  PlatformAddress,
  IPlatformAddress,
  PlatformSocial,
  IPlatformSocial,
  IPlatformSocialData
} from './index'

export class PlatformInfo implements IPlatformInfo {
  readonly id?: number
  name: string
  full_name: string
  email: string
  phones: string[]
  social?: IPlatformSocial[]
  nip: number
  regon: string
  address: IPlatformAddress
  account_number: string
  account_bank: string

  constructor(data?: IPlatformInfoData) {
    this.id = data?.id
    this.name = data?.name || 'BONIFIQUE LIFE'
    this.full_name = data?.full_name || 'Bonifique Life Anastasiya Halaburda'
    this.email = data?.email || 'bonifique.life@gmail.com'
    this.nip = data?.nip || 9412503387
    this.regon = data?.regon || ''
    this.account_number = data?.account_number || '57 1160 2202 0000 0004 7378 1243'
    this.account_bank = data?.account_bank || '«Millennium Bank Polska»'
    this.phones = data?.phones || [
      '+375 29 606 52 72',
      '+48 514 670 161'
    ]
    this.social = data?.social?.map((social: IPlatformSocialData) => new PlatformSocial(social))
    this.address = new PlatformAddress(data)
  }

  get key(): string {
    let id = this.id;
    return (id ? (id + '-') : '') + this.name;
  }
}
